// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d6997bb2","558":"cfe9209d","791":"da995f39"}[chunkId] + ".chunk.js";
};